<template>
  <div class="TestHomeTitle">
      <div class="TestHomeTitle_title">{{title}}</div>
      <div class="TestHomeTitle_subTitle">{{subTitle}}</div>
  </div>
</template>

<script>

export default {
  name: "TestHomeTitle",
  props:['title', 'subTitle'],
  data() {
    return {}
  },
  methods: {},
};
</script>
<style lang="scss">
.TestHomeTitle{
    .TestHomeTitle_title{
        font-size: 32px;
        font-family: PingFangSC, PingFangSC-Semibold;
        font-weight: 600;
        text-align: center;
        color: #19232b;
        line-height: 64px;
        letter-spacing: -1px;
    }
    .TestHomeTitle_subTitle{
        font-size: 18px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: center;
        color: #616a72;
        line-height: 50px;
    }
}  
</style>
